import React, { Component } from "react";
import axios from "../../../axios";
import * as url from "./../../../utils/url";
import * as actionCreators from "./../../../modules/actions/index";
import { connect } from "react-redux";
import sortBy from "lodash/sortBy";
import unionBy from "lodash/unionBy";
import findIndex from "lodash/findIndex";
import OfficeMates from "../../office/OfficeMates/OfficeMates";
import UsersList from "./UsersList";
import { Col, Button } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import {
  isTrivvyProduct,
  isTrivvyUrl,
  whiteLabelStyling,
  USERS_LIST_SUBTITLE,
} from "../../../utils/constants";
import FooterBar from "../../../components/FooterBar/FooterBar";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import UploadUsersModal from "../../trivia/Components/UploadUsersModal";
import { BiUser } from "react-icons/bi";
import { LuUploadCloud, LuUserPlus } from "react-icons/lu";
import "./users-list-bwai.css";

class Users extends Component {
  state = {
    selectedTab: 1,
    existingMapping: null,
    allOffices: [],
    industriesList: [],
    allOfficesWithInvitations: [],
    searchedTerm: "",
    sortType: "a-z",
    userCount: null,
    officeCount: null,
    uploadUsersModal: false,
  };

  goToInviteOfficeMates = () => {
    // console.log(this.props.history)
    // this.props.history.push('/home/office/invite-office-mates');
    this.props.history.push("/home/users/invite");
  };

  getUserCount = (val) => {
    console.log(val);
    this.setState({ userCount: val });
  };

  getOfficeCount = (val) => {
    console.log(val);
    this.setState({ officeCount: val });
  };

  componentDidMount() {
    if (isMobile) {
      window.scrollTo(0, 0);
      this.props.updateNavBar({
        title: "Enterprise Members",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
    }
  }

  setUploadUsersModal = (v) => {
    this.setState({ uploadUsersModal: v });
  };

  renderTabs = () => {
    const { selectedTab, uploadUsersModal } = this.state;
    const { role } = this.props.user.profile;
    let isSetupSkipped = this.props.user.profile.organizationId.isSetupSkipped;
    if (isSetupSkipped) {
      return (
        <div>
          <UsersList
            type="all"
            getUserCount={this.getUserCount}
            getOfficeCount={this.getOfficeCount}
            uploadUsersModal={this.state.uploadUsersModal} setUploadUsersModal={(v)=>{this.setState({uploadUsersModal:v})}}
            setNewUserCount={(val) => {
              this.setState((prevState) => ({
                userCount: prevState.userCount !== null ? prevState.userCount - val : null,
              }));
            }}
          />
        </div>
      );
    } else {
      if (role !== "Member") {
        if (selectedTab === 1) {
          return (
            <div>
              <UsersList
                type="all" uploadUsersModal={this.state.uploadUsersModal} setUploadUsersModal={(v)=>{this.setState({uploadUsersModal:v})}}
                getUserCount={this.getUserCount}
                getOfficeCount={this.getOfficeCount}
                setNewUserCount={(val) => {
                  this.setState((prevState) => ({
                    userCount: prevState.userCount !== null ? prevState.userCount - val : null,
                  }));
                }}
              />
            </div>
          );
        } else {
          return (
            <div>
              <UsersList
                type="office"
                getOfficeCount={this.getOfficeCount}
                uploadUsersModal={this.state.uploadUsersModal}
                setUploadUsersModal={(v) => this.setState({ uploadUsersModal: v })}
                setNewUserCount={(val) => {
                  this.setState((prevState) => ({
                    userCount: prevState.userCount !== null ? prevState.userCount - val : null,
                  }));
                }}
              />
            </div>
          );
        }
      } else {
        return (
          <div>
            <UsersList
              type="all"
              getUserCount={this.getUserCount}
              uploadUsersModal={this.state.uploadUsersModal}
              setUploadUsersModal={(v) => this.setState({ uploadUsersModal: v })}
              setNewUserCount={(val) => {
                this.setState((prevState) => {
                  console.log("val", val);
                  console.log("prevState.userCount", prevState.userCount);
                  return({
                  userCount: prevState.userCount !== null ? prevState.userCount - val : null,
                })});
              }}
            />
          </div>
        );
      }
    }
  };

  render() {
    const {
      selectedTab,
      userCount,
      officeCount,
      uploadUsersModal,
    } = this.state;
    let { user } = this.props;
    const { organizationId, email, role } = this.props.user.profile;
    let { isSetupSkipped } = organizationId;
    console.log(this.props.user);
    const cellLeft = isMobile ? "50%" : "180px";
    const cellWidth = isMobile ? "50%" : "170px";
    // console.log(allOfficesWithInvitations);
    return (
      <div>
        <div
          className={
            isMobile
              ? "mt-10 enterpriseMembersContainer bwai-users"
              : "enterpriseMembersContainer bwai-users"
          }
        >
          <div className="bwai-users-header">
            <div className="bwai-users-header-main">
              <div className="bwai-users-title-row">
                <span className="bwai-users-title">Users List</span>
                {userCount !== null ? (
                  <span className="bwai-users-count-pill">{userCount}</span>
                ) : null}
              </div>
              <div className="bwai-users-subtitle">{USERS_LIST_SUBTITLE}</div>
            </div>
            <div className="bwai-users-header-actions">
              {user && user.profile && user.profile.role === "Admin" && (
                <Button
                  className="bwai-btn-secondary"
                  onClick={this.goToInviteOfficeMates}
                >
                  <LuUserPlus size={16} className="mr-2" />
                  Invite
                </Button>
              )}

              {user && user.profile && user.profile.role === "Admin" && user.profile.orgAdmin && (
                <Button
                  className="bwai-users-btn-primary ml-2"
                  onClick={() => this.setState({ uploadUsersModal: true })}
                >
                  <LuUploadCloud size={16} className="mr-2" />
                  Upload users
                </Button>
              )}
            </div>
          </div>

          <div
            className="flex pb5 mt20"
            style={{ display: "none", borderBottom: "1px solid #D5D6D8" }}
          >
            <div
              className="users-tab"
              style={{ color: selectedTab === 1 ? "#333333" : "#A5A6AC" }}
              onClick={() => {
                this.setState({ selectedTab: 1 });
              }}
            >
              <div>
                All {userCount !== null ? <span>({userCount})</span> : null}
              </div>
            </div>

            {this.props.user.profile &&
            this.props.user.profile.officeId &&
            role != "Member" ? (
              <div
                className="users-tab"
                style={{ color: selectedTab === 2 ? "#333333" : "#A5A6AC" }}
                onClick={() => {
                  this.setState({ selectedTab: 2 });
                }}
              >
                <div>
                  Officemates{" "}
                  {officeCount !== null ? <span>({officeCount})</span> : null}
                </div>
              </div>
            ) : null}
          </div>
          <div>
            <div
            // className="selected-tab-underline"
            // style={whiteLabelStyling(['borderTopColor','backgroundColor'], this.props.user.profile.organizationId)}
            // style={{left:selectedTab === 1 ? '0px' : cellLeft,  width:selectedTab === 1 ? cellWidth : cellWidth}}
            ></div>
          </div>
          {this.renderTabs()}
        </div>
        {isMobile && !isTrivvyProduct() && <FooterBar {...this.props} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onIndustryChangeSuccess: (data) =>
      dispatch(actionCreators.industryChangeSuccess(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    orgEmailRemove: (data) => dispatch(actionCreators.orgEmailRemove(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
  };
};

// export default connect(mapStateToProps,mapDispatchToProps)(Users);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(Users, axios)));
